import React from "react";
import styles from "./index.module.css";
import Button from "shared/Button";
import Table from "shared/Table";

import { useDeleteExternal } from "./useDeleteExternal";

export function RemoveModalContent(props) {
  const { deletePlugin } = useDeleteExternal(
    props.record.iboNumber,
    props.onClose
  );

  return (
    <>
      <div style={{ width: "400px" }}>
        <Table>
          <thead>
            <tr>
              <th>Sponsor</th>
              <th>DateAdded</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{props.record.sponsor}</td>
              <td>{new Date(props.record.dateAdded).toLocaleDateString()}</td>
            </tr>
          </tbody>
          <tfoot />
        </Table>

        <div style={{ marginTop: "15px" }} />
        <Table>
          <thead>
            <th>Platinum</th>
            <th align="center">Emerald</th>
            <th>Diamond</th>
          </thead>
          <tbody>
            <tr>
              <td>{props.record.platinum}</td>
              <td>{props.record.emerald}</td>
              <td>{props.record.diamond}</td>
            </tr>
          </tbody>
          <tfoot />
        </Table>

        <div style={{ marginTop: "15px" }} />
        <Table>
          <thead>
            <th>WwgSignoff</th>
            <th>UplineSignoff</th>
          </thead>
          <tbody>
            <tr>
              <td>{props.record.wwgSignoff}</td>
              <td>{props.record.uplineSignoff}</td>
            </tr>
          </tbody>
          <tfoot />
        </Table>

        <div style={{ marginTop: "15px" }} />
        <Table>
          <thead>
            <th>Notes</th>
          </thead>
          <tbody>
            <tr>
              <td>{props.record.notes}</td>
            </tr>
          </tbody>
          <tfoot />
        </Table>
        <div className={styles.buttonRow}>
          <Button className={styles.cancelButton} onClick={props.onClose}>
            Cancel
          </Button>
          <Button
            className={styles.deleteButton}
            onClick={(e) => {
              e.preventDefault();
              deletePlugin(props.record.iboNumber);
            }}
          >
            Remove
          </Button>
        </div>
      </div>
    </>
  );
}
export default RemoveModalContent;
